
































































import Vue from "vue";
import BlogList from "@/components/blog/BlogList.vue";
import BlogCategoryList from "@/components/blog/BlogCategoryList.vue";

export default Vue.extend({
  name: "BlogManagement",
  components: {
    BlogList,
    BlogCategoryList,
  },
  data() {
    return {
      activeTab: 0, // 0 = posts tab, 1 = categories tab
      showDebug: false, // Toggle debugging information
    };
  },
  methods: {
    showHelp() {
      // Show a help dialog or redirect to help documentation
      this.$store.dispatch("setToast", {
        title: "Blog Management Help",
        type: "info",
        text: "Blog posts help you engage with your customers. Create categories to organize your content, then add blog posts with rich formatting and media.",
        timeout: 6000,
      });

      // Debug info
      console.log("Active Tab:", this.activeTab);
      console.log("Store BLOG_ state:", this.$store.state.BLOG_);
      console.log(
        "Store BLOG_CATEGORY_ state:",
        this.$store.state.BLOG_CATEGORY_
      );
    },
  },
  mounted() {
    // Initialize to make sure the tabs work correctly
    this.activeTab = 0;
    console.log("BlogManagement mounted. Active tab:", this.activeTab);

    // Log store state for debugging
    console.log("BLOG_ store module state:", this.$store.state.BLOG_);

    // Check if components are registered
    if (this.$options.components) {
      console.log(
        "BlogList component registered:",
        !!this.$options.components.BlogList
      );
      console.log(
        "BlogCategoryList component registered:",
        !!this.$options.components.BlogCategoryList
      );
    }
  },
});
